module.exports = __webpack_public_path__ + "static/media/branding.7432b737.png";